import { Card, CardContent } from "@/components/ui/card";
import { Badge } from "@/components/ui/badge";

const About = () => {
  const certifications = [
    "USDA 등록",
    "AAALAC International 인증",
    "MFDS 규제 준수",
    "IATA 생체동물 운송 규정"
  ];

  return (
    <section id="about" className="py-16 lg:py-24">
      <div className="container max-w-6xl mx-auto px-4 sm:px-6 lg:px-8">
        <div className="grid grid-cols-1 lg:grid-cols-2 gap-12 items-start">
          <div className="space-y-6">
            <h1 className="text-2xl md:text-3xl font-bold text-foreground mb-6">
              회사 소개
            </h1>
            <div className="space-y-5">
              <p className="text-base text-muted-foreground leading-relaxed">
                Central TG Inc. (센트럴티지<span style={{ fontSize: "70%" }} className="align-baseline">(주)</span>)는 미국 The Jackson Laboratory(JAX<sup>®</sup>)의 대한민국 공식 대리점으로서, 국제적으로 검증된 유전자변형 모델을 국내 연구자들에게 안정적이고 체계적으로 공급하고 있습니다.
              </p>
              
              <p className="text-base text-muted-foreground leading-relaxed">
                The Jackson Laboratory(JAX<sup>®</sup>)는 1929년 설립된 세계적 권위의 비영리 연구기관으로, 유전체학과 생명과학 분야에서 혁신적인 발견과 연구 성과를 지속적으로 선도해 왔습니다. 특히 유전자변형 모델 개발과 질환 연구를 위한 정밀한 동물 자원 관리에 있어 세계적으로 가장 신뢰받는 기관 중 하나로 평가받고 있습니다.
              </p>
              
              <p className="text-base text-muted-foreground leading-relaxed">
                Central TG Inc. (센트럴티지<span style={{ fontSize: "70%" }} className="align-baseline">(주)</span>)는 JAX의 이러한 연구 철학과 품질 기준을 충실히 이어받아, 암 연구, 면역학, 신경과학, 대사질환 및 희귀질환 연구 등 다양한 학문 분야에서 국내 연구자들이 세계적 수준의 실험환경을 경험할 수 있도록 지원합니다. 또한 여러 물류 및 연구 지원 노하우를 통해 연구자들이 필요로 하는 모델을 신속하고 안전하게 제공함으로써 대한민국 생명과학 연구의 발전에 기여하고 있습니다.
              </p>
            </div>
            
            <div className="space-y-6">
              <h2 className="text-xl font-semibold text-foreground">품질 및 규제 준수</h2>
              
              <div className="space-y-4">
                <p className="text-base text-muted-foreground leading-relaxed">
                  The Jackson Laboratory는 미국 내 USDA 등록과 AAALAC International 인증을 보유한 세계적 수준의 연구기관입니다.
                </p>
                <p className="text-base text-muted-foreground leading-relaxed">
                  Central TG Inc. (센트럴티지<span style={{ fontSize: "70%" }} className="align-baseline">(주)</span>)는 한국 식약처(MFDS) 수입 규제를 철저히 준수하여 동물을 안전하게 통관합니다.
                </p>
                <p className="text-base text-muted-foreground leading-relaxed">
                  모든 연구동물은 국제 기준에 따라 IATA 생체동물 운송 규정을 준수하며, 안전하고 윤리적인 절차로 배송됩니다.
                </p>
              </div>
            </div>
          </div>
          
          <div className="lg:pl-6">
            <Card className="overflow-hidden shadow-corporate mt-2">
              <CardContent className="p-0">
                <img 
                  src="/lovable-uploads/24cecd31-88b1-4d69-b5a6-0efe49afc0ef.png" 
                  alt="Official JAX distributor authorization letter"
                  className="w-full h-auto object-contain"
                />
              </CardContent>
            </Card>
          </div>
        </div>
      </div>
    </section>
  );
};

export default About;